import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"

// import Loader from "./elements/Loader"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import Products from "./Products"
import LoadMore from "./LoadMore"
import NoResults from "./NoResults"

export default function Serp() {
    const { query, response: { products }, loading } = useAppState();
    const foundProducts = products && products.total > 0;
    const [ facetsOpen, setFacetsOpen ] = useState(false);
    const [ mobileColumns, setMobileColumns ] = useState("2");
    const [ desktopColumns, setDesktopColumns ] = useState("2");

    useEffect(() => {
        document.querySelector('body')?.classList.remove('template_index');
        const headerSection = document.querySelector('.shopify-section-group-header-group');
        if(headerSection) {
            headerSection.classList.remove('shopify-section-header-fixed');
            headerSection.querySelector('.header-wrapper')?.setAttribute('data-fixed', 'false');
            headerSection.querySelector('header')?.classList?.remove('header--index-dark');
            const classesToRemove = ['desktop', 'mobile']
            headerSection.querySelectorAll('.header__logo').forEach(logoEl => {
                classesToRemove.forEach(className => {
                    logoEl.classList.remove(className);
                })
            })
        }
    }, [])

    useEffect(() => {
        if(window.nostojs)
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements([ "searchpage-nosto-3" ])
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    useEffect(() => {
        const titleEl = document.querySelector('title');
        if(!titleEl || !products?.total || !query?.query) return;
        titleEl.textContent = `Search: ${products.total} results found for "${query.query}"`
    }, [ query.query, products?.total ])

    useEffect(() => {
        (window.innerWidth < 750 && facetsOpen)
            ?   document.querySelector('body').classList.add('overflow-hidden')
            :   document.querySelector('body').classList.remove('overflow-hidden')
            
        return () => document.querySelector('body').classList.remove('overflow-hidden')
    }, [ facetsOpen ])

    const changeGridColumns = (event) => {
        (window.innerWidth > 990)
            ?   setDesktopColumns(event.target.value)
            :   setMobileColumns(event.target.value)
    }

    const toggleFacets = () => {
        setFacetsOpen(prevFacetsOpen => !prevFacetsOpen)
    }

    return (
        <div class="ns-serp" data-nosto-element="search">
            {foundProducts ? (
                <>
                    <Sidebar 
                        facetsOpen={facetsOpen}
                        toggleFacets={toggleFacets}
                    />
                    <div class="ns-serp-inner page-width">
                        <Toolbar 
                            facetsOpen={facetsOpen}
                            toggleFacets={toggleFacets}
                            mobileColumns={mobileColumns}
                            desktopColumns={desktopColumns}
                            changeGridColumns={changeGridColumns}
                        />
                        <Products
                            mobileColumns={mobileColumns}
                            desktopColumns={desktopColumns}
                        />
                        <LoadMore />
                    </div>
                    <div class="nosto_element" id="searchpage-nosto-3"></div>
                </>
            ) : (!foundProducts && !loading) ? (
                <NoResults />
            ) : ( null )
            }
        </div>
    )
}
